import axios from 'axios';
import Constants from "../services/Constants";

// This function fetches the chat history for a specific chat session
export const getChat = async ({ queryKey, pageParam = null }) => {
    const [_, chatId] = queryKey;
    const params = {
        chatId,
        limit: 10,
        lastEvaluatedKey: pageParam,
    };

    try {
        const res = await axios.get(Constants.GET_CHAT, {
            params,
        });
        return res.data;
    } catch (error) {
        console.error('getChat : ', error);
    }
}

// This function fetches all chat sessions for a specific user
export const getChats = async ({ pageParam = null }) => {
    const params = {
        limit: 10,
        lastEvaluatedKey: pageParam,
    };

    try {
        const res = await axios.get(Constants.GET_ALL_CHATS, {
            params,
        });
        return res.data;
    } catch (error) {
        console.error('getChats : ', error);
    }
}

// This function fetches chat suggestions based on the chat ID and refresh flag
export const getSuggestions = async ({ queryKey }) => {
    const [_, chatId, refresh] = queryKey;
    const params = {
        chatId,
        refresh,
    };

    try {
        const res = await axios.get(Constants.CHAT_SUGGESTIONS, {
            params,
        });
        return res.data;
    } catch (error) {
        console.error('getSuggestions : ', error);
        return [];
    }
}

// This function sends a prompt to the chat API and returns the response
export const sendPrompt = async (payload) => {
    try {
        const res = await axios.post(Constants.SEND_PROMPT, payload);
        return res.data;
    } catch (error) {
        console.error('sendPrompt : ', error);
        return {
            response: {
                text: "Sorry, unable to process the request!",
                role: "assistant",
                timestamp: new Date().toISOString(),
            }
        };
    }
}

// This function creates a new chat session
export const createChat = async (payload) => {
    try {
        const res = await axios.post(Constants.CREATE_CHAT, payload);
        return res.data;
    } catch (error) {
        console.error('createChat : ', error);
    }
}

// This function updates the title of an existing chat session
export const renameChat = async (payload) => {
    try {
        const res = await axios.patch(Constants.RENAME_CHAT, payload);
        return res.data;
    } catch (error) {
        console.error('updateChat : ', error);
    }
}

// This function deletes a chat session by its ID
export const deleteChat = async (payload) => {
    try {
        const res = await axios.delete(
            Constants.DELETE_CHAT,
            { data: payload }
        );
        return res.data;
    } catch (error) {
        console.error('deleteChat : ', error);
    }
}